import { useCallback, useEffect } from 'react';
import useToggle from '@stripcash/ui-kit/utils/hooks/useToggle';

import setUserSettingsService from 'common/services/userSettings/setUserSettingsService';
import bulkUserSettingsService from 'common/services/userSettings/bulkUserSettingsService';

import { UserSettings } from '../services/userSettings/types';

const usePrivateMode = ({ initial = false, shouldSave = true } = {}): [
  boolean,
  () => void,
] => {
  const [isPrivate, toggleMode, setPrivate] = useToggle(
    initial,
    useCallback(
      (mode) => {
        if (shouldSave) {
          setUserSettingsService({
            name: UserSettings.HeaderPrivateMode,
            value: String(mode),
          });
        }
      },
      [shouldSave],
    ),
  );

  useEffect(() => {
    if (shouldSave) {
      bulkUserSettingsService
        .get([
          {
            name: UserSettings.HeaderPrivateMode,
            format: 'text',
          },
        ])
        .catch(() => 'false')
        .then((value) => setPrivate(value === 'true'));
    }
  }, [shouldSave]);

  return [isPrivate, toggleMode];
};

export default usePrivateMode;
